(() => {
 if (window.trufaLightInitialized) return;
 window.trufaLightInitialized = true;
 const refresh = () => document.querySelectorAll('[data-trufa-light-scope]').forEach(scope => {
   const controls = scope.querySelector('[data-trufa-light-controls]');
   const pairs = [...scope.querySelectorAll('[data-trufa-light-pair]')];
   if (!controls) return;
   const hasPairs = pairs.length > 0;
   const simulated = pairs.some(pair => pair.hasAttribute('data-light-simulated'));
   if (hasPairs && !scope.dataset.light) scope.dataset.light = simulated ? 'on' : 'off';
   const note = controls.querySelector('[data-trufa-light-note]');
   const noteText = simulated ? 'Simulación visual sobre tus fotos' : 'Comparación fotográfica';
   if (note && note.textContent !== noteText) note.textContent = noteText;
   if (controls.hidden === hasPairs) controls.hidden = !hasPairs;
   pairs.forEach(pair => { if (pair.hidden) pair.hidden = false; });
   const button = controls.querySelector('[data-trufa-light-switch]');
   if (button.dataset.lightReady) return;
   button.dataset.lightReady = 'true';
   button.setAttribute('aria-checked', String(scope.dataset.light === 'on'));
   controls.querySelector('[data-trufa-light-label]').textContent = scope.dataset.light === 'on' ? 'Encendidas' : 'Apagadas';
   button.addEventListener('click', () => {
     const enabled = scope.dataset.light !== 'on';
     scope.dataset.light = enabled ? 'on' : 'off';
     controls.querySelector('[data-trufa-light-switch]').setAttribute('aria-checked', String(enabled));
     controls.querySelector('[data-trufa-light-label]').textContent = enabled ? 'Encendidas' : 'Apagadas';
   });
 });
 const start = () => {
   refresh();
   let queued = false;
   new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; refresh(); }); }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
 document.addEventListener('shopify:section:load', refresh);
})();
